import { useAuthStore } from "@/stores/authStore";
import { useModalStore } from "@/stores/modalStore";
import ModalQR from "@/UI/Modals/ModalQR.vue";
import { putLike, putDislike } from "@/api/axios.js";
import { useOpenPost } from "@/composables/useOpenPost.js";
import { computed } from "vue";

export function usePostActions(post, isModal, emit) {
  const authStore = useAuthStore();
  const modalStore = useModalStore();
  const { openPost } = useOpenPost([post.value || post]);

  const openModalQR = () => {
    modalStore.openModal({
      component: ModalQR,
      options: { lockScroll: true },
    });
  };

  const sendLike = async () => {
    if (!authStore.user) {
      openModalQR();
      return;
    }

    try {
      if (post.is_liked) {
        await putDislike(post.id);
        post.likes_qty -= 1;
      } else {
        await putLike(post.id);
        post.likes_qty += 1;
      }

      post.is_liked = !post.is_liked;
    } catch (e) {
      console.error(e);
    }
  };

  const openComments = () => {
    if (!authStore.user) {
      openModalQR();
      return;
    }

    if (isModal) {
      emit?.("toggleComments", true);
    } else {
      openPost(post.id, { showComments: true });
    }
  };

  const backgroundColor = computed(
    () => post?.metadata?.background_color || "#fff",
  );

  return {
    sendLike,
    openComments,
    backgroundColor,
  };
}
